import React from 'react';
import AboutBanner from './AboutBanner';





const About = () => {
 

  return (
    <div className="women-container">
     <br /><br />
      <AboutBanner/><br />
     
     <br /><br /><br />
    </div>
    
  );
};

export default About;
